export default __webpack_public_path__ + "static/media/me.cc92a164.jpg";